import { useState } from "react";
import { getFirebaseInitializationState } from "../config/firebase";

interface FirebaseInitState {
  isInitialized: boolean;
  isLoading: boolean;
  error: string | null;
  appCheckEnabled: boolean;
}

/**
 * Exposes the module-owned Firebase startup result to React.
 */
export function useFirebaseInit(): FirebaseInitState {
  const [state] = useState<FirebaseInitState>(getFirebaseInitializationState);

  return state;
}

export default useFirebaseInit;
